// src/LogIn.js
import { Component } from 'react';
import { properties } from './properties.js';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { apiPublicRequest, apiSecuredRequest} from './functions.js';
import NavBar from './LogInNavBar.js';
import i18n from './I18N/I18n.js'; 
import './css/logIn.css'; // Importar los estilos



class ResetPass extends Component {

  cambiarIdioma = (idioma) => {
          const { i18n } = this.props;
          i18n.changeLanguage(idioma);
          Cookies.set('idiomaPreferido', idioma, { expires: 365 }); // Guarda la preferencia por un año // Cambia el idioma usando i18n
      };
  
  _resetPass = async (email) => {
    let data = JSON.stringify({
      email: `${email}`
    });

    try {

      const resetPass = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/resetPassword`, data);
      Swal.fire(`${i18n.t('passwordReset')}`, '', 'success')
    } catch (err) {
      this.setState({ incorrectUser: true });
    }
  };

  constructor(props) {
    super(props);
    this.state = {
      incorrectUser: false,
      userName: '',
      userPassword: '',
    };
  }

  render() {
    return (
      
      <div className="login-container">
        
      <div className="login-content">
      <NavBar
          cambiarIdioma={this.cambiarIdioma}
        />
        <h2>Reset Password</h2>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            const email = this.email.value;
           
            this._resetPass(email);
          }}
        >
          <input
            type="text"
            ref={(email) => {
              this.email = email;
            }}
            placeholder="Email"
            className="custom-input-field"
            required
          />

          <div className="button-container">
            <button type="submit" className="btn">
            {i18n.t('resetPass')}
            </button>

          </div>

          <p className="error-message">
            {this.state.incorrectUser ? 'The information is wrong, please try again' : ''}
          </p>
        </form>
      </div>
    </div>
    );
  }
}

export default  withTranslation()(ResetPass);
